"use strict";

const GMap = () => {
    const init = () => {
        $(document).ready(function () {
            
            let $mapHolders = $('.js-map-holder');

            $mapHolders.each(function () {
                let $mapHolder = $(this);
                let $map = $mapHolder.find('.js-map');
                let lat = parseFloat($map.data('lat'));
                let lng = parseFloat($map.data('lng'));
                let pin = $map.data('pin');
                let activePin = $map.data('active-pin') !== undefined ? $map.data('active-pin') : $map.data('pin');
                let zoom = $map.data('zoom');
                let locations = $map.data('locations');
                let $info = $mapHolder.find('.js-display-home-info');
                let $close = $mapHolder.find('.js-display-home-close');
                let $toggle = $mapHolder.find('.js-map-toggle');
                let $accordions = $mapHolder.find('.js-accordion');
                
                let map_obj = new google.maps.Map($map[0], {
                    center: {lat, lng},
                    zoom: parseFloat(zoom),
                    disableDefaultUI: true,
                    styles: [
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#193341"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#2c5a71"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#29768a"
                                },
                                {
                                    "lightness": -37
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#406d80"
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#406d80"
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#3e606f"
                                },
                                {
                                    "weight": 2
                                },
                                {
                                    "gamma": 0.84
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "weight": 0.6
                                },
                                {
                                    "color": "#1a3541"
                                }
                            ]
                        },
                        {
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#2c5a71"
                                }
                            ]
                        }
                    ]
                });

                let i = 1;
                let points = [];
                locations.forEach((item) => {
                    if (item.lat && item.lng) {
                        points[i] = new google.maps.Marker({
                            position: {
                                "lat": parseFloat(item.lat),
                                "lng": parseFloat(item.lng)
                            },
                            map: map_obj,
                            icon: pin,
                            zIndex: 10
                        });
                        points[i]['id'] = item.id;
                        points[i].addListener('click', function () {
                            points.forEach((item) => {
                                if(item.id == this.id){
                                    item.setIcon(activePin);
                                }else{
                                    item.setIcon(pin);
                                }
                            });
                            if($info.length){
                                $info.removeClass('active')
                                $info.filter('[data-id="' + item.id + '"]').addClass('active')
                            }
                            if($accordions.length){
                                if(!$accordions.filter('[data-map-id="' + item.id + '"]').hasClass('active')){
                                    $accordions.filter('[data-map-id="' + item.id + '"]').find('.js-accordion-title').trigger('click');
                                }
                            }
                        });
                        i++;
                    }
                });

                if($close.length){
                    $close.on('click', function(){
                        let $parent = $(this).parents('.js-display-home-info');
                        $parent.removeClass('active');
                        $info.filter('[data-id="default"]').addClass('active');
                        points.forEach((item) => {
                            item.setIcon(pin);
                        });
                    });
                }

                if($toggle.length){
                    $toggle.on('click', function(){
                        $toggle.removeClass('active');
                        $(this).addClass('active');
                        if($(this).data('view') == 'map'){
                            $mapHolder.removeClass('list-view');
                            $mapHolder.addClass('map-view');
                        }else{
                            $mapHolder.removeClass('map-view');
                            $mapHolder.addClass('list-view');
                        }
                    });
                }

                if($accordions.length){
                    $accordions.find('.js-accordion-title').on('click', function(){
                        let $accordion = $(this).parent();
                        if($accordion.hasClass('active')){
                            points.forEach((item) => {
                                if(item.id == $accordion.data('map-id')){
                                    item.setIcon(activePin);
                                }else{
                                    item.setIcon(pin);
                                }
                            });
                        }else{
                            points.forEach((item) => {
                                item.setIcon(pin);
                            });
                        }
                    })
                }

                if(!$info.filter('[data-id="default"]').length){
                    new google.maps.event.trigger(points[1], 'click');
                }
            });
        });
    };

    return {
        init: init
    };
};

export default GMap;